import { shouldPollUpload, useSocialUploadPolling } from '@app/modules/social-export/publish';
import { WebAppCompositionSocialUploadItemDto } from '@mi-front/api-v2';
import { ComposeSocialExportUploadItemCard } from './ComposeSocialExportUploadItemCard';

interface ComposeSocialExportUploadItemProps {
  upload: WebAppCompositionSocialUploadItemDto;
}

/**
 * Single composition social upload row: polls while pending, then renders the card.
 */
export function ComposeSocialExportUploadItem({
  upload: initialUpload,
}: ComposeSocialExportUploadItemProps) {
  const shouldPoll = shouldPollUpload(initialUpload);

  const polledQuery = useSocialUploadPolling(initialUpload.id, {
    enabled: shouldPoll,
  });

  const upload = shouldPoll
    ? ((polledQuery.data ?? initialUpload) as WebAppCompositionSocialUploadItemDto)
    : initialUpload;

  return <ComposeSocialExportUploadItemCard upload={upload} />;
}
